import { useEffect, useState } from 'react'
import ApiClient from '../api'
import useIsMounted from '../hooks/use-is-mounted'

export interface Product {
  id: string
  name: string
  prices: Record<string, number>
  active: boolean
  // eslint-disable-next-line camelcase
  is_subscription: boolean
}

export function useProducts(apiClient: ApiClient): Product[] {
  const [products, setProducts] = useState([])
  const isMounted = useIsMounted()
  useEffect(() => {
    apiClient
      .getProducts()
      .then(products => isMounted.current && setProducts(products))
  }, [apiClient, isMounted])

  return products
}

const paygIds = ['payg-150', 'payg-300', 'payg-500']

export function usePaygProducts(apiClient: ApiClient) {
  const products = useProducts(apiClient)
  return {
    paygProducts: products.filter(
      (product: { id: string }) => paygIds.indexOf(product.id) > -1
    ),
    hasSubscription:
      products.length > 0
        ? products.some(p => p.active && p.is_subscription)
        : undefined,
  }
}

export enum Currency {
  eur = 'eur',
  usd = 'usd',
}

export const currencySymbol: Record<Currency, string> = {
  eur: '€',
  usd: '$',
}
